import SocialButton from "./SocialButton";

const handleSocialLogin = (user) => {
  console.log(user);
};

const handleSocialLoginFailure = (err) => {
  console.error(err);
};

const GoogleLogin = () => {
  return (
    <div className="google-btn login-btn d-sm-inline-block">
      <SocialButton
        provider="google"
        appId="YOUR_APP_ID"
        onLoginSuccess={handleSocialLogin}
        onLoginFailure={handleSocialLoginFailure}
      >
        Login with Google
      </SocialButton>
    </div>
  )
}

export default GoogleLogin;
